import script from "./MainActivateAccountComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MainActivateAccountComponent.vue?vue&type=script&setup=true&lang=js"

import "./MainActivateAccountComponent.vue?vue&type=style&index=0&id=42a5bc6f&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42a5bc6f"]])

export default __exports__